import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const AlertF24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M12 21.893c-5.523 0-10-4.477-10-10 0-5.522 4.477-10 10-10s10 4.478 10 10c0 5.523-4.477 10-10 10Zm0-15a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z' /></svg>);
